import React from 'react';

const Radio = ({
  id,
  name,
  label,
  className = '',
  labelClassName = '',
  ...props
}) => (
  <div className={`gzl-Radio ${className}`}>
    <input type="radio" id={id} name={name} required {...props} />
    <label className={labelClassName} htmlFor={id}>
      {label}
    </label>
  </div>
);

export default Radio;
